/* eslint max-len: 0 */
import React from 'react';
import i18n from '../libs/i18n';

import Section from './Section.jsx';
import { Layout, LayoutItem } from './Layout';

export default class SectionHistory extends React.Component {
  render() {
    const contentBg = require('images/history-bg.svg');
    const title = i18n.translate('history.title');
    const hsUrl = require('images/history-shoot-90.png');

    return (
      <Section id="history" color="white" contentBg={contentBg} title={title}>
        <Layout direction="column" align="center">
          <LayoutItem full>
            <Layout direction="column" fallbackToRowAt="wide-screens" align="center">
              <LayoutItem weight={2}>
                <p>{i18n.translate('history.p1')}</p>
                <p>{i18n.translate('history.p2')}</p>
              </LayoutItem>
              <LayoutItem weight={1}>
                <div className="history-shoot">
                  <img src={hsUrl} alt="{i18n.translate('history.advCaption')}" className="history-shoot--image" />
                  <div className="history-shoot--caption">
                    <div className="history-shoot--caption--text">{i18n.translate('history.advCaption')}</div>
                    <svg className="history-shoot--caption--triangle" viewBox="0 0 220 190">
                      <polygon points="0,0 220,60 120,190" />
                    </svg>
                  </div>
                </div>
              </LayoutItem>
            </Layout>
          </LayoutItem>
          <LayoutItem>
            <div className="history-sequence">
              <li><img src={require('../../images/history-cat-0.png')} alt="catalogue 0" /></li>
              <li><img src={require('../../images/history-cat-1.png')} alt="catalogue 1" /></li>
              <li><img src={require('../../images/history-cat-2.png')} alt="catalogue 2" /></li>
              <li><img src={require('../../images/history-cat-3.png')} alt="catalogue 3" /></li>
              <li><img src={require('../../images/history-cat-4.png')} alt="catalogue 4" /></li>
              <li><img src={require('../../images/history-cat-5.png')} alt="catalogue 5" /></li>
            </div>
          </LayoutItem>
        </Layout>
      </Section>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./web/js/components/SectionHistory.jsx
 **/